import { useEffect } from "react";
import { debounce } from "../utils/debounce";

export default function useDebounce(fn, ms) {
  const [debouncedFn, teardown] = debounce(fn, ms);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => () => teardown(), []);

  return debouncedFn;
}
